<template>
  <div class="bowler-profile-summary">
    <div class="bowler-profile-summary-data">
      <FontAwesomeIcon class="icon" icon="bowling-ball" />
      <span>{{ formatValue(bowler.activeMembership?.clubName) }}</span>

      <FontAwesomeIcon class="icon icon-mirrored" icon="bowling-ball" />
      <span>{{ formatValue(bowler.activeMembership?.associationName) }}</span>

      <FontAwesomeIcon class="icon" icon="envelope" />
      <span>{{ formatValue(bowler.email) }}</span>

      <FontAwesomeIcon class="icon" icon="phone" />
      <span>{{ formatValue(bowler.phoneNumber) }}</span>
    </div>

    <RouterLinkButton :to="{ path: '/profile' }">
      {{ $t('nav.profile') }}
    </RouterLinkButton>
  </div>
</template>

<script lang="ts" setup>
import RouterLinkButton from '@/components/common/RouterLinkButton.vue'
import { useBowlerStore } from '@/store/bowler-app/bowler'
import { formatValue } from '@/utils/format'

const bowler = useBowlerStore()
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/globals';

.bowler-profile-summary {
  display: flex;
  flex-flow: column nowrap;
  gap: 1em;

  .bowler-profile-summary-data {
    display: grid;
    grid-template-columns: 1.25em auto;
    gap: 0.75em;
    margin: 0 0.5em;
  }

  .icon {
    font-size: 1.25em;
    color: $color-accent;

    &.icon-mirrored {
      transform: scaleX(-100%);
    }
  }
}
</style>
